import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Cookies from "universal-cookie";
import GetProxy from "../../../app/GetProxy";
import { handleResponseCode } from "../../../app/utilities/helpers";


const proxy = GetProxy();
const cookies = new Cookies();

export const getAuditList = createAsyncThunk(
  "get/getData",
  async (props) => {
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");
    try {
      const { page, count, payload } = props;
      const response = await fetch(
        `${proxy}/auditLog/auditLogDetailsList/${page}/${count}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": Apitoken,
            USERNAME: User,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);


const initialState = {
  getAuditListData: [],
  error: "",
  auditLoading: false,
};

const AuditLogSlice = createSlice({
  name: "AuditLogSlice",
  initialState,
  reducers: {
    AuditLogSliceReset: () => {
      return initialState;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAuditList.pending, (state, action) => {
        state.auditLoading = true;
      })
      .addCase(getAuditList.fulfilled, (state, action) => {
        state.getAuditListData = action.payload;
        state.auditLoading = false;
      })
      .addCase(getAuditList.rejected, (state, action) => {
        state.auditLoading = false;
        state.getAuditListData = [];
        state.error = "Something went wrong";
      });
  },
});

export const { AuditLogSliceReset } =
  AuditLogSlice.actions;
export default AuditLogSlice.reducer;
